interface ScenePersonProps {
  // Feet position on the 600 x 440 scene canvas.
  x: number;
  y: number;
  skinClassName: string;
  bodyClassName: string;
  legsClassName?: string;
}

// Flat standing figure used in the industry hero scenes (SVG group, so it
// must sit inside an <svg>).
const ScenePerson = ({
  x,
  y,
  skinClassName,
  bodyClassName,
  legsClassName = "fill-ink",
}: ScenePersonProps) => (
  <g transform={`translate(${x} ${y})`}>
    <circle cx="0" cy="-118" r="17" className={skinClassName} />
    <path
      d="M-17 -126 q17 -22 34 0 q-6 -4 -17 -4 q-11 0 -17 4z"
      className="fill-ink"
    />
    <rect x="-20" y="-98" width="40" height="66" rx="14" className={bodyClassName} />
    <rect x="-17" y="-34" width="15" height="52" rx="7" className={legsClassName} />
    <rect x="2" y="-34" width="15" height="52" rx="7" className={legsClassName} />
    <rect
      x="-34"
      y="-92"
      width="15"
      height="46"
      rx="7"
      transform="rotate(8 -26 -92)"
      className={bodyClassName}
    />
    <rect
      x="19"
      y="-92"
      width="15"
      height="46"
      rx="7"
      transform="rotate(-8 26 -92)"
      className={bodyClassName}
    />
    <rect x="-20" y="16" width="19" height="8" rx="4" className="fill-ink" />
    <rect x="2" y="16" width="19" height="8" rx="4" className="fill-ink" />
  </g>
);

export default ScenePerson;
